import { Injectable } from "@angular/core";
import { createWarning } from "@core/helpers/create-validator.helper";
import { Store } from "@ngrx/store";
import { isBefore, isEqual } from "date-fns";
import { Revisione53State } from "../../../store/revisione53.reducers";

@Injectable({ providedIn: 'root' })
export class SezIIAccertamentoWarningService {

    constructor(
        private store: Store<Revisione53State>
    ) {
    }

    my_DataCompilazII = createWarning(this.store, myVerbale => {
        const my_DataCompilazII = myVerbale.my_SezioneII__Accertamento.my_DataCompilazII;
        const my_CkProposte = myVerbale.my_SezioneI__Rilevazione.my_Conclusioni.my_CkProposte;
        const my_StatoAccertamento = myVerbale.my_StatoAccertamento;
        const my_DataScadenzaAccertamento = myVerbale.my_SezioneII__Accertamento.my_DataScadenzaAccertamento;

        const beforeOrEqual = isBefore(new Date(my_DataCompilazII), new Date(my_DataScadenzaAccertamento)) || isEqual(new Date(my_DataCompilazII), new Date(my_DataScadenzaAccertamento));
        // console.log('my_DataCompilazII', new Date(my_DataCompilazII));
        // console.log('my_DataScadenzaAccertamento', my_DataScadenzaAccertamento);
        /* if (!(my_DataCompilazII === '' || my_CkProposte != '3' || my_StatoAccertamento != '1' || beforeOrEqual)) {
            return 'data successiva di più di 30gg la data di scadenza della diffida';
        } */
        //// verificare
        if (my_DataCompilazII === '') {
            return 'data successiva di più di 30gg la data di scadenza della diffida';
        }
    })

}
